import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("批量确认")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("批量使用")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看未设置银行卡人员")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("比例")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消比例")

import { ref, Ref, onActivated, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, {cpyCfig, orgCfig} from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/users/bank_cards/list': fetchList,
  // 获取-银行列表
  'POST/banks/list': bankListApi,
  // 批量确认-个人银行卡
  'PATCH/users/bank_cards/batch': batchConfirmApi,
  // 批量导入银行卡
  'POST/users/bank_cards/import': importApi,
  // 员工列表(不分页,下拉框)
  'GET/users/list': userListApi,
  // 批量插入
  'POST/users/bank_cards/batch_insert': batch_insertApi,
  // 修改-个人银行卡
  'PATCH/users/bank_cards': usersBank_cardsModifyApi,
  // 单个删除-个人银行卡
  'DELETE/users/bank_cards/{id}': bank_cardsDelApi,
  // 下载银行卡模板
  'GET/users/bank_cards/download': downloadCardsTemplateApi,
  // 导出银行卡
  'POST/users/bank_cards/export': exportCardsApi,
  // 批量使用‘
  'PATCH/users/bank_cards/use': useCardsApi,
  // 关闭和开始银行卡
  'PATCH/users/bank_cards/convert': convertApi,
  // 银行卡比例设置
  'PATCH/users/bank_cards/setRatio': setRatioApi,
  // 查询未录入银行卡人员
  'POST/users/bank_cards/unset': unsetUserApi,
  // 
  'PATCH/users/bank_cards/update_admin': update_adminApi,
} = Api

let fullUserList: any = ref([])
onBeforeMount(() => {
  userListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.label = `${_user.realName}(${_user.alias})`
      return _user
    })
  })
})
onActivated(() => {
  fetchData(MI_params)
})

const cardsTable: any = ref()
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let cardList: any = ref([])
const searchConfig = ref([
  {
    type: 'SELECT',
    label: '卡用途',
    value: '',
    upKey: 'purpose',
    options: [
      { label: '工资卡', id: '工资卡' },
      { label: '报销卡', id: '报销卡' },
      { label: '尽孝金卡', id: '尽孝金卡' },
    ],
    props: { clearable: true, placeholder: '请选择卡用途'},
    seleProps: {}
  },
  {
    type: 'SELECT',
    label: '卡状态',
    value: '',
    upKey: 'status',
    options: [
      { label: '已确认', id: true },
      { label: '待确认', id: false },
    ],
    props: { clearable: true, placeholder: '请选择卡状态'},
    seleProps: {}
  },
  {
    type: 'SELECT',
    label: '使用状态',
    value: '',
    upKey: 'locked',
    options: [
      { label: '已使用', id: true },
      { label: '未使用', id: false },
    ],
    props: { clearable: true, placeholder: '请选择使用状态'},
    seleProps: {}
  },
  {
    type: 'SELECT',
    label: '银行',
    value: '',
    upKey: 'bankId',
    selectFunc: bankListApi,
    options: [],
    props: { clearable: true, placeholder: '请选择银行', },
    seleProps: { 
      label: 'alias',
      valueName: 'id',
    }
  },
  {
    label: '持卡人',
    value: '',
    upKey: 'key',
    props: {clearable: true, placeholder: '请输入持卡人'},
  },
  cpyCfig(),
  orgCfig(),
  {
    type: 'SELECT',
    label: '人员状态',
    value: [],
    upKey: 'staffTypes',
    options: [
      { label: '转正', id: '转正', },
      { label: '试用期', id: '试用期', },
      { label: '兼职', id: '兼职', },
      { label: '离职', id: '离职', },
      { label: '实习生', id: '实习生', },
    ],
    seleProps: {},
    props: { placeholder: '请选择人员状态', clearable: true, multiple: true, 'collapse-tags': true }
  },
  {
    label: '卡号',
    value: '',
    upKey: 'account',
    props: {clearable: true, placeholder: '请输入卡号'},
  },
])

const searchHandle = (params: object) => {
  cardsTable.value.clearSelection()
  fetchData(params)
}

// 批量确认
const confirmHandle = () => {
  if(cardList.value.length === 0){
    ElMessage.warning('至少选择一条数据')
    return
  }
  if(cardList.value.some((e: any) => e.status === true)){
    ElMessage.warning('无法重复确认')
    return
  }

  ElMessageBox.confirm(
    '是否批量确认银行卡?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return batchConfirmApi({ids: cardList.value.map((e: any) => e.id)})
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('确认成功')
      fetchData(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
    })
}
// 批量使用
const batchUseHandle = () => {
  if(cardList.value.length === 0){
    ElMessage.warning('至少选择一条数据')
    return
  }
  if(cardList.value.some((e: any) => e.locked === true)){
    ElMessage.warning('无法重复使用')
    return
  }
  ElMessageBox.confirm(
    '是否批量使用?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return useCardsApi({ids: cardList.value.map((e: any) => e.id)})
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('使用成功')
      fetchData(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
    })
  
}

// 修改
const modifyFg = ref<boolean>(false)
let modifyCardEle = ref()
const modifyConfig: any = ref([
  {
    type: 'SELECT',
    label: '银行',
    value: '',
    upKey: 'bankId',
    selectFunc: bankListApi,
    options: [],
    rule: [{ required: true, message: '请选择银行', trigger: 'change' }],
    props: { clearable: true, placeholder: '请选择银行', },
    seleProps: { 
      label: 'alias',
      valueName: 'id',
    }
  },
  {
    label: '银行卡号',
    value: '',
    upKey: 'account',
    rule: [{ required: true, message: '请输入银行卡号', trigger: 'change' }],
    props: { clearable: true, placeholder: '请输入银行卡号', formatter: (value: string) => value.replace(/(\d{4})(?=\d)/g, '$1 ')},
  },
  {
    label: '开户行信息',
    value: '',
    upKey: 'location',
    props: {clearable: true, placeholder: '请输入开户行信息'},
  },
  {
    type: 'SELECT',
    label: '卡用途',
    value: '',
    upKey: 'purpose',
    rule: [{ required: true, message: '请选择卡用途', trigger: 'change' }],
    options: [
      { label: '工资卡', id: '工资卡' },
      { label: '报销卡', id: '报销卡' },
      { label: '奖金卡', id: '奖金卡' },
      { label: '尽孝金卡', id: '尽孝金卡' },
    ],
    props: { clearable: true, placeholder: '请选择卡用途'},
    seleProps: {},
    selectCb: (value: string) => {
      if(value !== '尽孝金卡'){
        modifyCardEle.value.dataObj.name = currentModifyRow.realName + `(${currentModifyRow.alias})`
        modifyConfig.value[4].rule[0].required = false
        modifyConfig.value[4].props.disabled = true
      } else {
        // 如果修改前是尽孝金卡
        if(currentModifyRow.purpose === '尽孝金卡'){
          modifyCardEle.value.dataObj.name = currentModifyRow.name
        } else {
          modifyCardEle.value.dataObj.name = ''
        }
        modifyConfig.value[4].rule[0].required = true
        modifyConfig.value[4].props.disabled = false
      }
    }
  },
  {
    label: "持卡人姓名",
    value: '',
    upKey: 'name',
    rule: [{ required: true, message: '请输入持卡人姓名', trigger: 'change' }],
    props: { clearable : true, disabled: true }
  },
])
let currentModifyRow: any = {}
const modifyHandle = (row: any) => {
  currentModifyRow = row
  if(row.purpose !== '尽孝金卡'){
    // modifyCardEle.value.dataObj.name = ''
    modifyConfig.value[4].rule[0].required = false
    modifyConfig.value[4].props.disabled = true
  } else {
    modifyConfig.value[4].rule[0].required = true
    modifyConfig.value[4].props.disabled = false
  }
  MI_modifyForm(row, modifyConfig, modifyFg, async(params: any) => {
    // 如果没有填写支行，弹框提示
    if(!params.location){
      await ElMessageBox.confirm(
        '开户行信息在银行APP里面可以查到。若未填写，可能银行付款会退回。',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
    }
    await usersBank_cardsModifyApi({
      ...row, 
      ...params, 
      account: params.account.replace(/\s+/g, ''),
      name: params.purpose === '尽孝金卡' ? params.name : '',
    })
    ElMessage.success('修改成功')
    modifyFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm(
    '是否确认删除?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return bank_cardsDelApi({id: row.id})
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('删除成功')
      fetchData(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
    })

}


// 上传成功回调
const repetitionFg = ref<boolean>(false)
let repetitionTable = ref([])
const upSuccessHandle = (rep: any) => {
  let {data} = rep
  if(data.length === 0){
    ElMessage.success('成功')
    return
  }
  repetitionTable.value = data.map((e: any)=> {
    e.userId = ''
    return e
  })
  repetitionFg.value = true

}

const comfirmHandle = async () => {
  if(repetitionTable.value.some((e: any) => !e.userId)){
    ElMessage.warning('请选择校对人员')
    return
  }
  await batch_insertApi({dtoList: repetitionTable.value })
  ElMessage.success('成功')
  fetchData(MI_params)
  repetitionFg.value = false
}

// 单个银行卡使用状态改变（switch开关改变）
const singleLockedChange = (_locked: boolean, row: any) => {

  MI_identify.value = true
  convertApi({id: row.id, deleted: _locked}).then(rep => {
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
    fetchData(MI_params)
  })
}

// 设置比例
const sectionalConfig = ref([
  {
    type: 'NUMBER',
    label: '比例',
    value: undefined,
    upKey: 'ratio',
    rule: [{ required: true, message: '请输入比例', trigger: 'change' }],
    props: {max: 100, min: 0, precision: 0, clearable: true, placeholder: '请输入比例'},
  },
])
const sectionalFg = ref<boolean>(false)
let currentRatioRow: any = {}
const proportionHandle = (row: any) => {
  currentRatioRow = row
  MI_modifyForm(row, sectionalConfig, sectionalFg, async(params: any) => {
    await setRatioApi({id: row.id, ...params})
    ElMessage.success('成功')
    sectionalFg.value = false
    fetchData(MI_params)
  })
}

const cancelRow = async () => {
  await setRatioApi({id: currentRatioRow.id, ratio: null} as any)
  ElMessage.success('成功')
    sectionalFg.value = false
    fetchData(MI_params)
}

// 查询未录入银行卡人员
const unsetEle  = ref()
const unsetConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'key',
  },
  {
    label: '身份证',
    value: '',
    upKey: 'cardld',
  },
  {
    type: 'SELECT',
    label: '人员状态',
    value: [],
    upKey: 'staffType',
    options: [
      { label: '转正', id: '转正' },
      { label: '试用期', id: '试用期' },
      { label: '兼职', id: '兼职' },
      { label: '实习生', id: '实习生' },
      { label: '离职', id: '离职' },
    ],
    props: { clearable: true, placeholder: '请选择人员状态', multiple: true, 'collapse-tags': true},
    seleProps: { label: 'label',valueName: 'id',}
  },
  {
    type: "TIME",
    label: "入职日期",
    value: '',
    upKey: 'dates',
    upProps: { startKey: 'hiredStartTime', endKey: 'hiredEndTime'},
    props: {
      type: 'monthrange',
      'value-format': 'YYYY-MM-DD'
    }
  },
])
const unsetFg = ref<boolean>(false)
let unsetTbData: any = ref([])
const showNullCradMember = () => {
  unsetFg.value = true
  /* unsetUserApi().then((rep) => {
    unsetTbData.value = rep
    MI_identify.value = false
    unsetFg.value = true
  }).catch(() => {
    MI_identify.value = false
  }) */
}
const searchUnsetMenber = (params: object) => {
  MI_identify.value = true
  unsetUserApi(params).then((rep) => {
    unsetTbData.value = rep
    MI_identify.value = false
  }).catch(() => {
    MI_identify.value = false
  })
}


// 编辑
const editFg = ref<boolean>(false)
const editConfig = ref([
  {
    label: '开户行信息',
    value: '',
    upKey: 'location',
    props: {clearable: true, placeholder: '请输入开户行信息'},
  },
  {
    type: 'SELECT',
    label: '银行',
    value: '',
    upKey: 'bankId',
    selectFunc: bankListApi,
    options: [],
    rule: [{ required: true, message: '请选择银行', trigger: 'change' }],
    props: { clearable: true, placeholder: '请选择银行', },
    seleProps: { 
      label: 'alias',
      valueName: 'id',
    }
  },
])
const editHandle = (row: any) => {
  MI_modifyForm(row, editConfig, editFg, async (params: object) => {
    await update_adminApi({...params, id: row.id})
    ElMessage.success('编辑成功')
    editFg.value = false
    fetchData(MI_params)
  })
}


// ------格式化银行卡号
const bankCardFormat = (cardNumber: any) => {
  if(!cardNumber){
    return ''
  }
  // 移除所有非数字字符
  const cleanedNumber = (cardNumber + '').replace(/\D/g, '');
  // 将数字按每4位分组，使用空格隔开
  const formattedNumber = cleanedNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
  return formattedNumber;
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "用户银行卡搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
            initSearch: false,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "success",
        plain: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (batchUseHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_TheUpBtn, {
        class: "ml-10",
        showBtn: true,
        upText: '批量导入',
        upFetch: _unref(importApi),
        upParams: {},
        onUpSuccess: upSuccessHandle
      }, {
        default: _withCtx(() => [
          _createVNode(_component_eptBtn, {
            type: "primary",
            exportFn: _unref(downloadCardsTemplateApi),
            exportText: '下载银行卡模板',
            isDirect: true
          }, null, 8, ["exportFn"])
        ]),
        _: 1
      }, 8, ["upFetch"]),
      _createVNode(_component_el_tooltip, {
        effect: "dark",
        content: "请先搜索后再导出",
        placement: "bottom-end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_eptBtn, {
            type: "primary",
            exportFn: _unref(exportCardsApi),
            exportParam: _unref(MI_params),
            exportText: '导出银行卡'
          }, null, 8, ["exportFn", "exportParam"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "ml-10",
        onClick: showNullCradMember
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onSelectionChange: _cache[2] || (_cache[2] = ((row) => _isRef(cardList) //@ts-ignore
 ? cardList.value = row : cardList = row)),
      "row-key": "id",
      ref_key: "cardsTable",
      ref: cardsTable,
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          "reserve-selection": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "持卡人",
          prop: "name",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            (row.purpose === '尽孝金卡')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.realName + `(${row.alias})的亲属` + row.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.realName + `(${row.alias})`), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "银行卡号",
          prop: "account",
          "show-overflow-tooltip": "",
          formatter: (row) => bankCardFormat(row.account)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "银行简称",
          prop: "bankAlias",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "开户行信息",
          prop: "location",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "卡用途",
          prop: "purpose",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "确认状态",
          prop: "status",
          "show-overflow-tooltip": "",
          formatter: (row) => row.status === false ? '待确认': '已确认'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "使用状态",
          prop: "locked",
          "show-overflow-tooltip": "",
          formatter: (row) => row.locked === false ? '未使用': '已使用'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "新增日期",
          prop: "createdAt",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "作废日期",
          prop: "obsoleteAt",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "启用停用",
          prop: "deleted",
          width: "210"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_switch, {
              modelValue: row.deleted,
              "onUpdate:modelValue": ($event: any) => ((row.deleted) = $event),
              "inactive-text": "作废",
              "active-text": "启用",
              onChange: (locked) => singleLockedChange(locked, row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "210"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                (row.status === false)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (modifyHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row)),
                  disabled: row.locked === true 
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"]),
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (proportionHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (editHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100, 300, 500, 800],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: repetitionFg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((repetitionFg).value = $event)),
      title: "重复人员列表"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: comfirmHandle
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(repetitionTable)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "name",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "银行账号",
              prop: "account",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "用途",
              prop: "purpose",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, { label: "校对人员" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_select, {
                  modelValue: row.userId,
                  "onUpdate:modelValue": ($event: any) => ((row.userId) = $event),
                  placeholder: "请选择员工",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fullUserList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.userId,
                        label: item.label,
                        value: item.userId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modifyFg).value = $event)),
      title: "修改银行卡"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "开户行信息:表示哪个支行办的，比如一张招商银行，在xx支行办理的，就填写 招商银行xx支行",
          type: "warning",
          effect: "dark",
          closable: false
        }),
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref_key: "modifyCardEle",
              ref: modifyCardEle
            }, {
        searchConfig: modifyConfig.value,
        submitText: '确定'
        }), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "设置银行卡比例",
      modelValue: sectionalFg.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((sectionalFg).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "比例数值最大为100",
          type: "warning",
          effect: "dark",
          closable: false
        }),
        (sectionalFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: sectionalConfig.value,
          submitText: '确定'
        })), {
              btnGroup: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "danger",
                  onClick: cancelRow
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "未录入银行卡人员",
      modelValue: unsetFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((unsetFg).value = $event)),
      draggable: "",
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_isRef(unsetTbData) //@ts-ignore
 ? unsetTbData.value = [] : unsetTbData = []))
    }, {
      default: _withCtx(() => [
        (unsetFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref_key: "unsetEle",
              ref: unsetEle
            }, {
          initSearch: false,
          title: true,
          searchConfig: unsetConfig.value,
        }, { onSearchFn: searchUnsetMenber }), null, 16))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(unsetTbData),
          "max-height": "500"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "realName",
              "show-voerflow-tooltip": ""
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row.realName + `(${row.alias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "在职状态",
              prop: "staffType",
              "show-voerflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "入职日期",
              prop: "hiredTime",
              "show-voerflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "转正日期",
              prop: "positiveDate",
              "show-voerflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "离职日期",
              prop: "departureDate",
              "show-voerflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(MI_identify)]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editFg).value = $event)),
      title: "编辑"
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref_key: "modifyCardEle",
              ref: modifyCardEle
            }, {
        searchConfig: editConfig.value,
        submitText: '确定'
        }), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})